// extracted by mini-css-extract-plugin
export default {"base":"DwowD","avatar":"_tSBF","details":"YR3Lc","bold":"q8YYA","email":"cwzbj","name":"GR3bD"};